export default "__VITE_ASSET__BJUDE3yn__"